import { render, staticRenderFns } from "./Responsables.vue?vue&type=template&id=ff02685e"
import script from "./Responsables.vue?vue&type=script&lang=js"
export * from "./Responsables.vue?vue&type=script&lang=js"
import style0 from "./Responsables.vue?vue&type=style&index=0&id=ff02685e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports